import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  useEffect(()=>{
    const paymentPlan = localStorage.getItem("plan_type")
    if(paymentPlan){
      loginWithRedirect({authorizationParams: {
        screen_hint: "signup",
      }})
    }else{
      loginWithRedirect()
    }
    
  },[])

  return (
    <div className="flex justify-center items-center h-screen">
      {/* <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={() => loginWithRedirect()}
      >
        Authorize
      </button> */}
    </div>
  );
};

export default LoginButton;
